var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventPlanning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.40234 3.31445H33.0883",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82227 8.54736L19.4501 8.54736",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82227 12.802L19.4501 12.802",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.81445,
    y: 3.31445,
    width: 26.7283,
    height: 19.2131,
    rx: 1,
    stroke: "black",
    strokeWidth: 1.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82227 17.0566L19.4501 17.0566",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2461 22.5275L17.2461 30.8339",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2461 1.06641L17.2461 3.31441",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2461 26.6799L24.14 31.3136",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.207 26.7623L10.0134 30.9156",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8125 7.83981L23.4689 8.87919C23.6559 9.17533 24.0816 9.19239 24.2917 8.91215L25.6829 7.05664",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8125 12.2285L23.4689 13.2679C23.6559 13.564 24.0816 13.5811 24.2917 13.3008L25.6829 11.4453",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8125 16.6211L23.4689 17.6604C23.6559 17.9566 24.0816 17.9736 24.2917 17.6934L25.6829 15.8379",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventPlanning);
export default __webpack_public_path__ + "static/media/EventPlanning.748aa190c4209abcdb34053f7aa76ed5.svg";
export { ForwardRef as ReactComponent };